import localforage from "localforage";

import {
    apiUrl as rootUrl,
    apiVersion
} from "../../config";

export async function kickFromGroup (
    chatId,
    memberId,
) {
    const token = await localforage.getItem("nakamian.admin-token");
    const response = await fetch(
        `${ rootUrl }/${ apiVersion }/chat/${ chatId }/member/${ memberId }`,
        {
            "method": "DELETE",
            "mode": "cors",
            "headers": {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${ token }`
            },
        }
    );

    if (response.ok) {
        return true;
    }

    if (response.status >= 400) {
        throw await response.text();
    }

    throw "Internal server error";
}

export default kickFromGroup;
